// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Keyframes ──────────────────────────────────────────────────────────── */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.3; }
}

/* ─── Wrapper & card ─────────────────────────────────────────────────────── */
.pc-wrapper {
  padding: 20px;
  width: 100%;
}

.pc-card {
  width: 100%;
  max-width: 960px;
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 40px 80px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.03);
  margin: 0 auto;
}

/* ─── Header ─────────────────────────────────────────────────────────────── */
.pc-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 28px;
}

.pc-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
}

.pc-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent);
  box-shadow: 0 0 8px var(--accent);
  animation: pulse 2s infinite;
  flex-shrink: 0;
}

.pc-section-label {
  color: var(--color-muted);
  font-size: 11px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.pc-perf-row   { display: flex; align-items: baseline; gap: 20px; }
.pc-perf-group { display: flex; align-items: baseline; gap: 8px; }

.pc-ticker-name {
  font-size: 32px;
  color: var(--color-white);
  font-weight: 700;
  letter-spacing: -0.02em;
}

.pc-perf-value {
  font-size: 22px;
  font-weight: 700;
}

.pc-perf-value--spx     { color: var(--accent); }
.pc-perf-value--mtt-pos { color: var(--color-blue); }
.pc-perf-value--mtt-neg { color: var(--color-danger); }

.pc-divider    { width: 1px; height: 28px; background: #2a2a35; }
.pc-date-range { color: #444; font-size: 11px; margin-top: 4px; }

.pc-preset-row {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

/* ─── Preset buttons ─────────────────────────────────────────────────────── */
.preset-btn {
  background: transparent;
  border: 1px solid #222;
  color: var(--color-dim);
  padding: 5px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.15s;
  letter-spacing: 0.05em;
}
.preset-btn:hover  { border-color: #444; color: var(--color-text); }
.preset-btn.active {
  border-color: var(--accent);
  color: var(--accent);
  background: rgba(0,0,0,0.5);
  box-shadow: 0 0 8px rgba(0,217,126,0.2);
}

/* ─── Chart ──────────────────────────────────────────────────────────────── */
.pc-chart-wrapper { height: 380px; margin-bottom: 8px; }

.pc-loading-text {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 13px;
  font-variant-numeric: tabular-nums;   /* the counter doesn't jitter */
}
.pc-loading-count {
  color: #666;
  font-size: 11px;
  text-align: center;
  padding: 0 12px;
}

/* ─── Range slider ───────────────────────────────────────────────────────── */
.pc-slider-section { margin-top: 12px; }

.pc-slider-meta {
  display: flex;
  justify-content: space-between;
  color: #333;
  font-size: 10px;
  margin-bottom: 6px;
  letter-spacing: 0.08em;
}

.pc-slider-end-labels {
  display: flex;
  justify-content: space-between;
  color: #333;
  font-size: 10px;
  margin-top: 6px;
}

.perf-slider { width: 100%; height: 20px; position: relative; cursor: default; }
.perf-slider-track { top: 50%; transform: translateY(-50%); height: 4px; border-radius: 4px; }
.perf-slider-track-0 { background: #1e1e24; }
.perf-slider-track-1 { background: var(--gradient-slider); }
.perf-slider-track-2 { background: #1e1e24; }
.perf-slider-thumb {
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: ew-resize;
  outline: none;
  border: 2px solid var(--color-bg);
}
.perf-slider-thumb-0 { background: var(--color-accent); box-shadow: 0 0 8px rgba(0,217,126,0.5); }
.perf-slider-thumb-1 { background: var(--color-blue);   box-shadow: 0 0 8px rgba(0,168,255,0.5); }

/* ─── Hint ───────────────────────────────────────────────────────────────── */
.pc-hint-row {
  display: flex;
  justify-content: space-between;
  color: #333;
  font-size: 10px;
  margin-top: 8px;
  letter-spacing: 0.08em;
}

/* ─── Trades table ───────────────────────────────────────────────────────── */
.pc-trades-section    { margin-top: 24px; }

.pc-trades-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.pc-trades-label {
  color: var(--color-muted);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.pc-trades-count { color: #333; font-size: 10px; }

.pc-table-wrapper {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;
}

.pc-table-head,
.pc-table-row {
  display: grid;
  grid-template-columns: 28px 0.7fr 0.8fr 0.8fr 0.8fr 0.8fr 0.7fr 0.8fr;
}

.pc-table-head {
  padding: 8px 12px;
  background: var(--color-bg-sub);
  border-bottom: 1px solid var(--color-border);
  font-size: 10px;
  color: var(--color-dim);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.pc-table-head-right { text-align: right; }

.pc-table-scroll { height: 250px; overflow-y: auto; }

.pc-table-empty {
  padding: 20px 12px;
  text-align: center;
  color: #333;
  font-size: 11px;
}

.pc-table-row {
  padding: 7px 12px;
  border-bottom: 1px solid var(--color-bg-row);
  font-size: 11px;
  color: #aaa;
  transition: background 0.1s;
  cursor: default;
  background: transparent;
}

.pc-table-row--active { background: rgba(0,168,255,0.04); }
.pc-table-row:hover   { background: var(--color-bg-row); }

/* ─── Table cells ────────────────────────────────────────────────────────── */
.pc-dot-cell    { display: flex; align-items: center; }

.pc-active-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-accent);
  box-shadow: 0 0 6px var(--color-accent);
  animation: pulse 2s infinite;
}

.pc-exit-date-cell {
  display: flex;
  align-items: right;
  justify-content: right;
  color: #666;
  font-size: 11px;
}

.pc-exit-date-cell--active {
  color: var(--color-blue);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.pc-entry-date-cell {
  display: flex;
  align-items: right;
  justify-content: right;
  color: #666;
  font-size: 11px;
  filter: blur(5px);
}

.pc-entry-price-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #aaa;
  filter: blur(5px);
  -webkit-user-select: none;
          user-select: none;
}

.pc-trades-section--unblurred .pc-entry-date-cell,
.pc-trades-section--unblurred .pc-entry-price-cell,
.pc-trades-section--unblurred .pc-position-cell {
  filter: none;
  -webkit-user-select: auto;
          user-select: auto;
}

.pc-ticker-cell {
  display: flex;
  align-items: center;
  color: var(--color-text);
  font-weight: 500;
}

.pc-price-cell {
  display: grid;
  grid-template-columns: 1fr 10ch;
  align-items: center;
  color: #aaa;
}

.pc-price-cell--active { color: var(--color-accent); }

.pc-amount { text-align: right; }

/* Currency code sits at the cell's left edge, value at the right.
   Inherits the cell colour so it matches the price (incl. active accent). */
.pc-ccy {
  padding-left: 40px;
  font-size: 10px;
  letter-spacing: 0.03em;
}

.pc-position-cell {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  filter: blur(5px);
  -webkit-user-select: none;
          user-select: none;
}

.pc-perf-cell {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 600;
}

.pc-perf-cell--pos { color: var(--color-accent); }
.pc-perf-cell--neg { color: var(--color-danger); }

/* ─── Scrollbar ──────────────────────────────────────────────────────────── */
.trades-scroll::-webkit-scrollbar       { width: 6px; }
.trades-scroll::-webkit-scrollbar-track { background: #1e1e24; border-radius: 4px; }
.trades-scroll::-webkit-scrollbar-thumb {
  background: var(--gradient-scroll);
  border-radius: 4px;
}
.trades-scroll::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #00ff94, #33b5ff);
}

/* ─── Source badges ──────────────────────────────────────────────────────── */
.pc-source-row {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pc-source-chip {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 10px;
  letter-spacing: 0.05em;
}

.pc-source-chip--live {
  background: rgba(0,217,126,0.08);
  border: 1px solid rgba(0,217,126,0.2);
  color: var(--color-accent);
}

.pc-source-chip--backend-mock {
  background: rgba(255,165,2,0.08);
  border: 1px solid rgba(255,165,2,0.25);
  color: #ffa502;
}

.pc-source-chip--mock {
  background: rgba(255,71,87,0.08);
  border: 1px solid rgba(255,71,87,0.2);
  color: var(--color-danger);
}

/* ─── Footer ─────────────────────────────────────────────────────────────── */
.pc-footer {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--color-bg-row);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pc-footer-text {
  color: #2a2a35;
  font-size: 10px;
}

.pc-footer-text--left { letter-spacing: 0.1em; }

/* ─── Responsive: tablet & below (≤768px) ────────────────────────────────── */
@media (max-width: 768px) {
  .pc-wrapper { padding: 12px; }

  .pc-card {
    padding: 20px;
    border-radius: 12px;
  }

  /* Stack header info above the preset buttons; let the buttons wrap */
  .pc-header-row {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
  }

  .pc-preset-row {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .pc-ticker-name { font-size: 28px; }
  .pc-perf-value  { font-size: 20px; }

  .pc-chart-wrapper { height: 300px; }

  .pc-table-scroll { height: 220px; }

  /* Drop the entry date & entry price columns (blurred without a subscription)
     and re-flow the grid to the remaining six columns so cells stay aligned:
     dot · ticker · exit date · exit price · position · perf */
  .pc-table-head,
  .pc-table-row {
    grid-template-columns: 22px 1fr 0.95fr 0.85fr 0.8fr 0.8fr;
  }

  .pc-th-entry-date,  .pc-entry-date-cell,
  .pc-th-entry-price, .pc-entry-price-cell {
    display: none;
  }
}

/* ─── Responsive: phones (≤480px) ────────────────────────────────────────── */
@media (max-width: 480px) {
  .pc-wrapper { padding: 8px; }

  .pc-card {
    padding: 14px;
    border-radius: 10px;
  }

  .pc-perf-row { gap: 12px; }

  .pc-ticker-name { font-size: 22px; }
  .pc-perf-value  { font-size: 16px; }

  /* Spread preset buttons across the row for easier tapping */
  .pc-preset-row { gap: 5px; }
  .preset-btn {
    flex: 1 1 auto;
    text-align: center;
    padding: 7px 8px;
  }

  .pc-chart-wrapper { height: 240px; }

  .pc-table-scroll { height: 200px; }

  /* Also drop the position column on the narrowest screens:
     dot · ticker · exit date · exit price · perf */
  .pc-table-head,
  .pc-table-row {
    grid-template-columns: 18px 1.3fr 1fr 0.9fr 0.85fr;
    padding-left: 10px;
    padding-right: 10px;
  }

  .pc-th-position, .pc-position-cell { display: none; }

  /* Stack the footer notes vertically */
  .pc-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/components/PerformanceComparison.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,YAAY,EAAE;AAC5B;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,6EAA6E;EAC7E,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,iBAAiB,aAAa,EAAE,qBAAqB,EAAE,SAAS,EAAE;AAClE,iBAAiB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE;;AAEjE;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B,oBAAoB,EAAE;AAChD,0BAA0B,wBAAwB,EAAE;AACpD,0BAA0B,0BAA0B,EAAE;;AAEtD,iBAAiB,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAChE,iBAAiB,WAAW,EAAE,eAAe,EAAE,eAAe,EAAE;;AAEhE;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,qBAAqB,kBAAkB,EAAE,wBAAwB,EAAE;AACnE;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,+EAA+E;AAC/E,oBAAoB,aAAa,EAAE,kBAAkB,EAAE;;AAEvD;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kCAAkC,IAAI,+BAA+B;AACvE;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+EAA+E;AAC/E,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,eAAe,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC/E,qBAAqB,QAAQ,EAAE,2BAA2B,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC7F,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,kCAAkC,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;AACnC;AACA,uBAAuB,+BAA+B,EAAE,uCAAuC,EAAE;AACjG,uBAAuB,6BAA6B,IAAI,uCAAuC,EAAE;;AAEjG,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E,wBAAwB,gBAAgB,EAAE;;AAE1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,mBAAmB,WAAW,EAAE,eAAe,EAAE;;AAEjD;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qEAAqE;AACvE;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4CAA4C;EAC5C,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,uBAAuB,iBAAiB,EAAE;;AAE1C,mBAAmB,aAAa,EAAE,gBAAgB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;;AAEA,wBAAwB,gCAAgC,EAAE;AAC1D,wBAAwB,+BAA+B,EAAE;;AAEzD,+EAA+E;AAC/E,kBAAkB,aAAa,EAAE,mBAAmB,EAAE;;AAEtD;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;AACb;;AAEA,yBAAyB,0BAA0B,EAAE;;AAErD,aAAa,iBAAiB,EAAE;;AAEhC;4EAC4E;AAC5E;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qBAAqB,0BAA0B,EAAE;AACjD,qBAAqB,0BAA0B,EAAE;;AAEjD,+EAA+E;AAC/E,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,mBAAmB,EAAE,kBAAkB,EAAE;AACnF;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,qDAAqD;AACvD;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB,qBAAqB,EAAE;;AAE/C,+EAA+E;AAC/E;EACE,cAAc,aAAa,EAAE;;EAE7B;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,qEAAqE;EACrE;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,eAAe,EAAE;;EAEnC,oBAAoB,aAAa,EAAE;;EAEnC,mBAAmB,aAAa,EAAE;;EAElC;;8DAE4D;EAC5D;;IAEE,yDAAyD;EAC3D;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,+EAA+E;AAC/E;EACE,cAAc,YAAY,EAAE;;EAE5B;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,eAAe,SAAS,EAAE;;EAE1B,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,eAAe,EAAE;;EAEnC,4DAA4D;EAC5D,iBAAiB,QAAQ,EAAE;EAC3B;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,oBAAoB,aAAa,EAAE;;EAEnC,mBAAmB,aAAa,EAAE;;EAElC;mDACiD;EACjD;;IAEE,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,qCAAqC,aAAa,EAAE;;EAEpD,sCAAsC;EACtC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF","sourcesContent":["/* ─── Keyframes ──────────────────────────────────────────────────────────── */\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.3; }\n}\n\n/* ─── Wrapper & card ─────────────────────────────────────────────────────── */\n.pc-wrapper {\n  padding: 20px;\n  width: 100%;\n}\n\n.pc-card {\n  width: 100%;\n  max-width: 960px;\n  background: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 40px 80px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.03);\n  margin: 0 auto;\n}\n\n/* ─── Header ─────────────────────────────────────────────────────────────── */\n.pc-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 28px;\n}\n\n.pc-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n\n.pc-live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--accent);\n  box-shadow: 0 0 8px var(--accent);\n  animation: pulse 2s infinite;\n  flex-shrink: 0;\n}\n\n.pc-section-label {\n  color: var(--color-muted);\n  font-size: 11px;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n}\n\n.pc-perf-row   { display: flex; align-items: baseline; gap: 20px; }\n.pc-perf-group { display: flex; align-items: baseline; gap: 8px; }\n\n.pc-ticker-name {\n  font-size: 32px;\n  color: var(--color-white);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.pc-perf-value {\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.pc-perf-value--spx     { color: var(--accent); }\n.pc-perf-value--mtt-pos { color: var(--color-blue); }\n.pc-perf-value--mtt-neg { color: var(--color-danger); }\n\n.pc-divider    { width: 1px; height: 28px; background: #2a2a35; }\n.pc-date-range { color: #444; font-size: 11px; margin-top: 4px; }\n\n.pc-preset-row {\n  display: flex;\n  gap: 6px;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n}\n\n/* ─── Preset buttons ─────────────────────────────────────────────────────── */\n.preset-btn {\n  background: transparent;\n  border: 1px solid #222;\n  color: var(--color-dim);\n  padding: 5px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.15s;\n  letter-spacing: 0.05em;\n}\n.preset-btn:hover  { border-color: #444; color: var(--color-text); }\n.preset-btn.active {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: rgba(0,0,0,0.5);\n  box-shadow: 0 0 8px rgba(0,217,126,0.2);\n}\n\n/* ─── Chart ──────────────────────────────────────────────────────────────── */\n.pc-chart-wrapper { height: 380px; margin-bottom: 8px; }\n\n.pc-loading-text {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;   /* the counter doesn't jitter */\n}\n.pc-loading-count {\n  color: #666;\n  font-size: 11px;\n  text-align: center;\n  padding: 0 12px;\n}\n\n/* ─── Range slider ───────────────────────────────────────────────────────── */\n.pc-slider-section { margin-top: 12px; }\n\n.pc-slider-meta {\n  display: flex;\n  justify-content: space-between;\n  color: #333;\n  font-size: 10px;\n  margin-bottom: 6px;\n  letter-spacing: 0.08em;\n}\n\n.pc-slider-end-labels {\n  display: flex;\n  justify-content: space-between;\n  color: #333;\n  font-size: 10px;\n  margin-top: 6px;\n}\n\n.perf-slider { width: 100%; height: 20px; position: relative; cursor: default; }\n.perf-slider-track { top: 50%; transform: translateY(-50%); height: 4px; border-radius: 4px; }\n.perf-slider-track-0 { background: #1e1e24; }\n.perf-slider-track-1 { background: var(--gradient-slider); }\n.perf-slider-track-2 { background: #1e1e24; }\n.perf-slider-thumb {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  cursor: ew-resize;\n  outline: none;\n  border: 2px solid var(--color-bg);\n}\n.perf-slider-thumb-0 { background: var(--color-accent); box-shadow: 0 0 8px rgba(0,217,126,0.5); }\n.perf-slider-thumb-1 { background: var(--color-blue);   box-shadow: 0 0 8px rgba(0,168,255,0.5); }\n\n/* ─── Hint ───────────────────────────────────────────────────────────────── */\n.pc-hint-row {\n  display: flex;\n  justify-content: space-between;\n  color: #333;\n  font-size: 10px;\n  margin-top: 8px;\n  letter-spacing: 0.08em;\n}\n\n/* ─── Trades table ───────────────────────────────────────────────────────── */\n.pc-trades-section    { margin-top: 24px; }\n\n.pc-trades-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.pc-trades-label {\n  color: var(--color-muted);\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.pc-trades-count { color: #333; font-size: 10px; }\n\n.pc-table-wrapper {\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.pc-table-head,\n.pc-table-row {\n  display: grid;\n  grid-template-columns: 28px 0.7fr 0.8fr 0.8fr 0.8fr 0.8fr 0.7fr 0.8fr;\n}\n\n.pc-table-head {\n  padding: 8px 12px;\n  background: var(--color-bg-sub);\n  border-bottom: 1px solid var(--color-border);\n  font-size: 10px;\n  color: var(--color-dim);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.pc-table-head-right { text-align: right; }\n\n.pc-table-scroll { height: 250px; overflow-y: auto; }\n\n.pc-table-empty {\n  padding: 20px 12px;\n  text-align: center;\n  color: #333;\n  font-size: 11px;\n}\n\n.pc-table-row {\n  padding: 7px 12px;\n  border-bottom: 1px solid var(--color-bg-row);\n  font-size: 11px;\n  color: #aaa;\n  transition: background 0.1s;\n  cursor: default;\n  background: transparent;\n}\n\n.pc-table-row--active { background: rgba(0,168,255,0.04); }\n.pc-table-row:hover   { background: var(--color-bg-row); }\n\n/* ─── Table cells ────────────────────────────────────────────────────────── */\n.pc-dot-cell    { display: flex; align-items: center; }\n\n.pc-active-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--color-accent);\n  box-shadow: 0 0 6px var(--color-accent);\n  animation: pulse 2s infinite;\n}\n\n.pc-exit-date-cell {\n  display: flex;\n  align-items: right;\n  justify-content: right;\n  color: #666;\n  font-size: 11px;\n}\n\n.pc-exit-date-cell--active {\n  color: var(--color-blue);\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n}\n\n.pc-entry-date-cell {\n  display: flex;\n  align-items: right;\n  justify-content: right;\n  color: #666;\n  font-size: 11px;\n  filter: blur(5px);\n}\n\n.pc-entry-price-cell {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #aaa;\n  filter: blur(5px);\n  user-select: none;\n}\n\n.pc-trades-section--unblurred .pc-entry-date-cell,\n.pc-trades-section--unblurred .pc-entry-price-cell,\n.pc-trades-section--unblurred .pc-position-cell {\n  filter: none;\n  user-select: auto;\n}\n\n.pc-ticker-cell {\n  display: flex;\n  align-items: center;\n  color: var(--color-text);\n  font-weight: 500;\n}\n\n.pc-price-cell {\n  display: grid;\n  grid-template-columns: 1fr 10ch;\n  align-items: center;\n  color: #aaa;\n}\n\n.pc-price-cell--active { color: var(--color-accent); }\n\n.pc-amount { text-align: right; }\n\n/* Currency code sits at the cell's left edge, value at the right.\n   Inherits the cell colour so it matches the price (incl. active accent). */\n.pc-ccy {\n  padding-left: 40px;\n  font-size: 10px;\n  letter-spacing: 0.03em;\n}\n\n.pc-position-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  filter: blur(5px);\n  user-select: none;\n}\n\n.pc-perf-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-weight: 600;\n}\n\n.pc-perf-cell--pos { color: var(--color-accent); }\n.pc-perf-cell--neg { color: var(--color-danger); }\n\n/* ─── Scrollbar ──────────────────────────────────────────────────────────── */\n.trades-scroll::-webkit-scrollbar       { width: 6px; }\n.trades-scroll::-webkit-scrollbar-track { background: #1e1e24; border-radius: 4px; }\n.trades-scroll::-webkit-scrollbar-thumb {\n  background: var(--gradient-scroll);\n  border-radius: 4px;\n}\n.trades-scroll::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #00ff94, #33b5ff);\n}\n\n/* ─── Source badges ──────────────────────────────────────────────────────── */\n.pc-source-row {\n  margin-top: 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pc-source-chip {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 10px;\n  letter-spacing: 0.05em;\n}\n\n.pc-source-chip--live {\n  background: rgba(0,217,126,0.08);\n  border: 1px solid rgba(0,217,126,0.2);\n  color: var(--color-accent);\n}\n\n.pc-source-chip--backend-mock {\n  background: rgba(255,165,2,0.08);\n  border: 1px solid rgba(255,165,2,0.25);\n  color: #ffa502;\n}\n\n.pc-source-chip--mock {\n  background: rgba(255,71,87,0.08);\n  border: 1px solid rgba(255,71,87,0.2);\n  color: var(--color-danger);\n}\n\n/* ─── Footer ─────────────────────────────────────────────────────────────── */\n.pc-footer {\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--color-bg-row);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pc-footer-text {\n  color: #2a2a35;\n  font-size: 10px;\n}\n\n.pc-footer-text--left { letter-spacing: 0.1em; }\n\n/* ─── Responsive: tablet & below (≤768px) ────────────────────────────────── */\n@media (max-width: 768px) {\n  .pc-wrapper { padding: 12px; }\n\n  .pc-card {\n    padding: 20px;\n    border-radius: 12px;\n  }\n\n  /* Stack header info above the preset buttons; let the buttons wrap */\n  .pc-header-row {\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 20px;\n  }\n\n  .pc-preset-row {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .pc-ticker-name { font-size: 28px; }\n  .pc-perf-value  { font-size: 20px; }\n\n  .pc-chart-wrapper { height: 300px; }\n\n  .pc-table-scroll { height: 220px; }\n\n  /* Drop the entry date & entry price columns (blurred without a subscription)\n     and re-flow the grid to the remaining six columns so cells stay aligned:\n     dot · ticker · exit date · exit price · position · perf */\n  .pc-table-head,\n  .pc-table-row {\n    grid-template-columns: 22px 1fr 0.95fr 0.85fr 0.8fr 0.8fr;\n  }\n\n  .pc-th-entry-date,  .pc-entry-date-cell,\n  .pc-th-entry-price, .pc-entry-price-cell {\n    display: none;\n  }\n}\n\n/* ─── Responsive: phones (≤480px) ────────────────────────────────────────── */\n@media (max-width: 480px) {\n  .pc-wrapper { padding: 8px; }\n\n  .pc-card {\n    padding: 14px;\n    border-radius: 10px;\n  }\n\n  .pc-perf-row { gap: 12px; }\n\n  .pc-ticker-name { font-size: 22px; }\n  .pc-perf-value  { font-size: 16px; }\n\n  /* Spread preset buttons across the row for easier tapping */\n  .pc-preset-row { gap: 5px; }\n  .preset-btn {\n    flex: 1 1 auto;\n    text-align: center;\n    padding: 7px 8px;\n  }\n\n  .pc-chart-wrapper { height: 240px; }\n\n  .pc-table-scroll { height: 200px; }\n\n  /* Also drop the position column on the narrowest screens:\n     dot · ticker · exit date · exit price · perf */\n  .pc-table-head,\n  .pc-table-row {\n    grid-template-columns: 18px 1.3fr 1fr 0.9fr 0.85fr;\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .pc-th-position, .pc-position-cell { display: none; }\n\n  /* Stack the footer notes vertically */\n  .pc-footer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
